export const licenseTypes = [
  { id: 2, name: 'Licensed' },
  { id: 3, name: 'Managed Services' },
];